import requestSender from "./base/requestSender";

export default function(axiosInstance){
   const base = 'comments'
    return {

        getComments(payload){
            return requestSender('get', base, payload);
        },
        getCallInfoComments(payload){
            return requestSender('get', base + '/get-call-info-comments', payload);
        },
        saveCallInfoComment(payload){
            return requestSender('post', base + '/save-call-info-comment', payload);
        },
    }
}